import * as React from "react"
import { cn } from "@shared/utils"
import { JSX } from "react";

 
/**
 * Creates a styled React component from a built-in HTML element tag.
 *
 * Supports:
 * - Default class names
 * - Ref forwarding
 * - Developer-friendly display names
 *
 * @template K - A key from both JSX.IntrinsicElements and HTMLElementTagNameMap
 * @param tag - The HTML tag to render (e.g., 'div', 'table')
 * @param defaultClassName - Default CSS classes applied to the component
 * @param displayName - Name for React DevTools
 */
export function createComponent<
  K extends keyof JSX.IntrinsicElements & keyof HTMLElementTagNameMap
>(
  tag: K,
  defaultClassName: string,
  displayName: string
) {
  const Component = React.forwardRef<
    HTMLElementTagNameMap[K],
    React.ComponentPropsWithoutRef<K>
  >(({ className, ...props }, ref) =>
    React.createElement(tag, {
      ref,
      className: cn(defaultClassName, className),
      ...props,
    })
  );

  Component.displayName = displayName;
  return Component;
}
